/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { SignatureDrawPad } from './Components/SignatureDrawPad';
import { SignatureDrawControls } from './Components/SignatureDrawControls';

/**
 * SignatureDrawPad Component
 * @returns {Element}
 * @constructor
 */
export function DrawPadWrapper({ fileUri, workerScriptUri }) {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      margin: '32px 0',
      flexFlow: 'column',
      alignItems: 'center',
    }}
    >
      <SignatureDrawPad fileUri={fileUri} workerScriptUri={workerScriptUri} />
      <SignatureDrawControls />
    </Box>
  );
}

DrawPadWrapper.propTypes = {
  fileUri: PropTypes.string.isRequired,
  workerScriptUri: PropTypes.string.isRequired,
};
